module.exports = __webpack_public_path__ + "static/media/v4_logo.4bcfbb27.png";